export const billboardRoute = '/cartelera/:area(zona-\d+)/:slug';
export const cinemaRoute = '/cine/:id/:slug/:date(fecha-\d+)?/:format(formato-[a-z0-9,_]+)?/:lang(idioma-[a-z,]+)?/:hours(horas-\d+a\d+)?';
export const checkoutRoute = '/checkout/:id';
export const snapchatLensesRoute = '/realidad-aumentada';
export const loopPackagesRoute = '/usuario/loop/paquetes';
export const yearRecap2025Route = '/recap-2025';